"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePlatform = void 0;
exports.normaliseMobileOS = normaliseMobileOS;
exports.isMobileMetadata = isMobileMetadata;
var MobilePlatform;
(function (MobilePlatform) {
    MobilePlatform["IOS"] = "iOS";
    MobilePlatform["IPADOS"] = "iPadOS";
    MobilePlatform["ANDROID"] = "Android";
})(MobilePlatform || (exports.MobilePlatform = MobilePlatform = {}));
// Order matters: 'iPadOS' contains the substring 'ios', so iPad must be
// matched first to avoid being mislabeled as iOS.
const ipadPlatformRegex = /ipad/i;
const iosPlatformRegex = /ios|iphone/i;
const androidPlatformRegex = /android/i;
/**
 * Normalises a raw OS/device string from a mobile SDK payload (e.g.
 * `axeDevice.os` or the value surfaced as `metadata.platform.name`) to a
 * canonical `MobilePlatform` enum value, or returns `null` when the input
 * is missing or doesn't match a known platform for some edge-cases.
 *
 * @example
 *   normaliseMobileOS('iOS')       // MobilePlatform.IOS
 *   normaliseMobileOS('iPad')      // MobilePlatform.IPADOS
 *   normaliseMobileOS('iPhone 15') // MobilePlatform.IOS
 *   normaliseMobileOS('Android')   // MobilePlatform.ANDROID
 *   normaliseMobileOS('')          // null
 *   normaliseMobileOS(undefined)   // null
 */
function normaliseMobileOS(name) {
    if (typeof name !== 'string' || name.length === 0) {
        return null;
    }
    if (ipadPlatformRegex.test(name)) {
        return MobilePlatform.IPADOS;
    }
    if (iosPlatformRegex.test(name)) {
        return MobilePlatform.IOS;
    }
    if (androidPlatformRegex.test(name)) {
        return MobilePlatform.ANDROID;
    }
    return null;
}
/**
 * Mobile results carry platform/app metadata stamped by the mobile→web
 * converter (`convertMobileResult`) and preserved through dedupe; web results
 * never populate these fields.
 */
function isMobileMetadata(metadata) {
    return (normaliseMobileOS(metadata?.platform?.name) !== null ||
        typeof metadata?.appIdentifier === 'string');
}
//# sourceMappingURL=mobilePlatform.js.map